import { ModalProps } from "antd/lib/modal/Modal";
import { Input, Modal, Spin } from "antd";
import Style from "./index.module.scss";
import React, { ChangeEvent, useContext, useEffect } from "react";
import Form, { useForm } from "rc-field-form";
import FieldWithErrorHaveLabel from "../../../../../components/FieldWithErrorHaveLabel";
import { ResultMessage } from "../../../../../components/ResultMessage";
import { errorMessage } from "../../../../../service/service";
import {
    EditMeetingProps,
    getMeetingDetail,
    MeetingType,
    saveMeeting,
    streamPipe
} from "../../../../../service/meeting";
import useRequestFn from "../../../../../utils/useRequestFn";
import { CourseContext } from "../../../Store";

interface DataModalInstance {
    setPayload: (payload: any) => void;
}

interface DataModalProps extends ModalProps {
    onOk?: () => void;
    onCancel?: () => void;
    onSuccess: () => void;
    PAY_LOAD?: { id: string | null };
}

interface FormProp {
    title: string;
    text: string;
    url: string;
    time: string;
}
const EditMeetingModal = React.forwardRef<DataModalInstance, DataModalProps>(
    ({ onSuccess, onOk, onCancel, PAY_LOAD, ...props }) => {
        const [form] = useForm<FormProp>();

        const [saveData, { loading }] = useRequestFn(saveMeeting);
        const { course } = useContext(CourseContext);

        const [getData, { loading: getLoading }] =
            useRequestFn(getMeetingDetail);

        async function init() {
            if (PAY_LOAD?.id) {
                const data = await getData({ id: PAY_LOAD.id });
                form.setFields([
                    { name: "text", value: data.text },
                    { name: "title", value: data.title },
                    { name: "url", value: data.url },
                    { name: "time", value: data.time }
                ]);
            }
        }

        useEffect(() => {
            init();
        }, [PAY_LOAD]);

        async function onFinish(data: FormProp) {
            const postParams: EditMeetingProps = {
                text: data.text,
                time: data.time,
                title: data.title,
                url: data.url,
                weekTimeId: course.weekTimeId
            };
            if (PAY_LOAD?.id) {
                postParams.id = PAY_LOAD.id;
            }

            await saveData(postParams);
            onSuccess();
        }

        function onInfoChange(e: ChangeEvent<HTMLTextAreaElement>) {
            try {
                const water = streamPipe(e.target.value, MeetingType.Tencent);
                form.setFields([
                    { name: "title", value: water.title },
                    { name: "url", value: water.url },
                    { name: "time", value: water.time }
                ]);
            } catch (e) {
                form.resetFields();
                ResultMessage.error(errorMessage(e));
            }
        }

        return (
            <Modal
                {...props}
                onCancel={onCancel}
                maskClosable={false}
                width={800}
                title="编辑会议"
                onOk={form.submit}>
                <Spin spinning={[loading, getLoading].some(i => i)}>
                    <div className={Style.root}>
                        <Form form={form} onFinish={onFinish}>
                            <FieldWithErrorHaveLabel
                                label="会议信息："
                                require
                                rules={[
                                    {
                                        required: true,
                                        message: "请粘贴会议信息"
                                    }
                                ]}
                                name="text">
                                <Input.TextArea
                                    rows={10}
                                    onChange={onInfoChange}
                                    maxLength={500}
                                    placeholder="请直接粘贴完整的会议链接进行自动解析"
                                />
                            </FieldWithErrorHaveLabel>
                            <FieldWithErrorHaveLabel
                                label="会议主题："
                                name="title">
                                <Input disabled />
                            </FieldWithErrorHaveLabel>
                            <FieldWithErrorHaveLabel
                                label="会议链接："
                                name="url">
                                <Input disabled />
                            </FieldWithErrorHaveLabel>
                            <FieldWithErrorHaveLabel
                                require
                                rules={[
                                    {
                                        required: true,
                                        message: "请粘贴会议信息"
                                    }
                                ]}
                                label="会议时间："
                                name="time">
                                <Input disabled />
                            </FieldWithErrorHaveLabel>
                        </Form>
                    </div>
                </Spin>
            </Modal>
        );
    }
);

EditMeetingModal.displayName = "EditMeetingModal";
export default EditMeetingModal;
